import { createConfig, createGetConfig, defineConfigSchema, parseApplicationMode } from '@repo/env-variables';

const configSchema = defineConfigSchema({
  appUrl: { envKey: 'VITE_APP_URL', type: 'string', required: true },
  restApiUrl: { envKey: 'VITE_REST_API_URL', type: 'string', required: true },
  graphqlUrl: { envKey: 'VITE_GRAPHQL_URL', type: 'string', required: true },
  legacyApiUrl: { envKey: 'VITE_LEGACY_API_URL', type: 'string', required: true },
  qrUrlDomain: { envKey: 'VITE_QR_URL_DOMAIN', type: 'string', required: true },
  allowedHosts: { envKey: 'VITE_ALLOWED_HOSTS', type: 'string', required: true },
  mapsKey: { envKey: 'VITE_GOOGLE_MAPS_KEY', type: 'string', required: true },
  mapsId: { envKey: 'VITE_GOOGLE_MAPS_ID', type: 'string', required: true },
  parkingSearchHost: { envKey: 'VITE_TYPESENSE_API_HOST', type: 'string', required: true },
  parkingSearchPort: { envKey: 'VITE_TYPESENSE_API_PORT', type: 'number', required: true },
  parkingSearchProtocol: { envKey: 'VITE_TYPESENSE_API_PROTOCOL', type: 'protocol', required: true },
  parkingSearchKey: { envKey: 'VITE_TYPESENSE_API_KEY', type: 'string', required: true },
  parkingSearchCollection: { envKey: 'VITE_TYPESENSE_API_COLLECTION', type: 'string', required: true },
  shopUrl: { envKey: 'VITE_SHOP_URL', type: 'string', required: true },
  sentryDsn: { envKey: 'VITE_SENTRY_DSN', type: 'string', required: false },
  webStatisticsId: { envKey: 'VITE_WEB_STATISTICS_ID', type: 'string', required: false },
  useMockRepository: { envKey: 'VITE_USE_MOCK_REPOSITORY', type: 'boolean', required: false, default: false },
  maintenancePlannedReturnDate: { envKey: 'VITE_MAINTENANCE_PLANNED_RETURN_DATE', type: 'string', required: false },
});

let config!: ReturnType<typeof createConfig<typeof configSchema>>;
export let configError: string | undefined;

try {
  config = createConfig(configSchema, import.meta.env, {
    applicationMode: parseApplicationMode(import.meta.env.VITE_APPLICATION_MODE),
  });
} catch (error) {
  console.log(error);
  configError = error instanceof Error ? error.message : String(error);
}

export const getConfig = createGetConfig(config);
